import {
  HomeOutlined as HomeOutlinedIcon,
  Logout as LogoutIcon,
  ManageHistory as ManageHistoryIcon,
  PlaylistAddCheckOutlined as PlaylistAddCheckOutlinedIcon
} from "@mui/icons-material";
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography
} from "@mui/material";
import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import Logo from "../../assets/img/Logo";
import { getUserName, logout } from "../../services/auth";

const getStyle = (type) => {
  const path = window.location.pathname;

  const styles = {
    "/inicio": { color: "#FBAF17" },
    // "/orcamentos": { color: "#FBAF17" },
    "/motor": { color: "#FBAF17" },
    "/orcamentos/call-center": { color: "#FBAF17" },
    "/orcamentos/canal-do-agente": { color: "#FBAF17" },
    "/": { color: "#fff" },
  };

  return path === type ? styles[type] : styles["/"];
};

//DEPOIS FAZER IMPORT DO userRole
const DashboardNavbar = ({ to, onMobileNavOpen, ...rest }) => {

  return (
    <AppBar elevation={0} {...rest}>
      <Toolbar>
        <RouterLink to="/">
          <Logo width={130}/>
        </RouterLink>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <RouterLink to="/inicio" style={getStyle("/inicio")}>
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  p: 2,
                }}
              >
                <HomeOutlinedIcon />
                <Typography sx={{ ml: 1 }}>Início</Typography>
              </Box>
            </RouterLink>
            {/* <RouterLink
              to="/orcamentos"
              style={getStyle("/orcamentos")}
            >
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  p: 2,
                }}
              >
                <PlaylistAddCheckOutlinedIcon />
                <Typography sx={{ ml: 1 }}>Orçamentos</Typography>
              </Box>
            </RouterLink> */}

            <RouterLink
              to="/orcamentos/call-center"
              style={getStyle("/orcamentos/call-center")}
            >
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  p: 2,
                }}
              >
                <PlaylistAddCheckOutlinedIcon />
                <Typography sx={{ ml: 1 }}>Orçamentos Call Center</Typography>
              </Box>
            </RouterLink>

            <RouterLink
              to="/orcamentos/canal-do-agente"
              style={getStyle("/orcamentos/canal-do-agente")}
            >
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  p: 2,
                }}
              >
                <PlaylistAddCheckOutlinedIcon />
                <Typography sx={{ ml: 1 }}>Orçamentos Canal do Agente</Typography>
              </Box>
            </RouterLink>

            <RouterLink to="/motor" style={getStyle("/motor")}>
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  p: 2,
                }}
              >
                <ManageHistoryIcon />
                <Typography sx={{ ml: 1 }}>Motor</Typography>
              </Box>
            </RouterLink>
          </Box>
        </Box>
        <Box>
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box
              sx={{
                alignItems: "center",
                display: "flex",
                flexDirection: "column",
                p: 2,
              }}
            >
              <Typography color="textTertiary" variant="h5">
                {getUserName()}
              </Typography>
              <Typography color="textTertiary" variant="body2">
                {process.env.REACT_APP_VERSION}
              </Typography>
            </Box>

            <IconButton
              onClick={(_) => {
                logout();
                window.location.href = "/login";
              }}
              aria-label="LogoutIcon"
            >
              <LogoutIcon sx={{ color: "#ffffff" }} fontSize="medium" />
            </IconButton>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func,
};

export default DashboardNavbar;
